<template>
    <div class="text-align-center">
      <img :src="vehicleIcon" :alt="vehicleAltText" width="80" />
    </div>
  </template>

  <script>
  export default {
    name: 'VehicleIcon',
    props: {
      vehicleType: {
        type: Number,
        required: true,
      },
      quotationType: {
        type: String,
        required: true,
      },
    },
    computed: {
      vehicleIcon() {
        if (this.vehicleType === 1) {
          return this.quotationType === 'ruote-classiche'
            ? require('../../../images/project-img/ico-classic-red.png')
            : require('../../../images/project-img/Ico Auto.svg');
        } else if (this.vehicleType === 2) {
          return require('../../../images/project-img/ico-comm-v.png');
        } else {
          return '';
        }
      },
      vehicleAltText() {
        if (this.vehicleType === 1) {
          return this.quotationType === 'ruote-classiche'
            ? 'Ruote Classiche icon'
            : 'Auto icon';
        } else if (this.vehicleType === 2) {
          return 'Veicoli commerciali icon';
        } else {
          return '';
        }
      },
    },
  };
  </script>



// WEBPACK FOOTER //
// resources/js/app/components/VehicleIcon.vue